import Table from 'react-bootstrap/Table'

import {
  attendanceTone,
  formatInteger,
  formatPercent,
} from './attendanceIntelligenceUtils'

export default function AttendanceIntelligenceSegmentBreakdown({
  segmentBreakdown,
}) {
  if (!segmentBreakdown?.length) {
    return (
      <p className="text-muted small mb-0">
        No segment breakdown available for this event yet.
      </p>
    )
  }

  return (
    <Table responsive className="attendance-segment-table mb-0">
      <thead>
        <tr>
          <th>Segment</th>
          <th>Sold</th>
          <th>Scanned</th>
          <th>Attendance</th>
          <th>No-show</th>
        </tr>
      </thead>
      <tbody>
        {segmentBreakdown.map((row) => {
          const tone = attendanceTone(row.attendanceRate)
          return (
            <tr key={row.id} className={`attendance-segment-row--${tone}`}>
              <td>{row.label}</td>
              <td>{formatInteger(row.ticketsSold)}</td>
              <td>{formatInteger(row.ticketsScanned)}</td>
              <td>{formatPercent(row.attendanceRate)}</td>
              <td>{formatPercent(row.noShowRate)}</td>
            </tr>
          )
        })}
      </tbody>
    </Table>
  )
}
